const tableCellGroup = {
  Typography: 'Do you really want to delete this item?'
};

export default tableCellGroup;
